import axios from "axios";
const cors = require('cors');


export function blcContactPageData() {
    
     return new Promise((resolve,reject)=>{

        axios.get('https://blcadmin.brac.net/api/blc-contact',cors()).then(response =>{

            resolve(response);
        });
     });
}

// http://localhost:1337/blc-contact
//http://34.123.182.161/blc-contact
//https://blcadmin.brac.net/blc-contact